export default {
  MEETING_API: 'https://2pduiuqnph.execute-api.us-east-1.amazonaws.com/confqa',
  WSS: 'wss://hbpvqp0g63.execute-api.us-east-1.amazonaws.com/confqa',
  SIGNED_API: 'https://wjdgb55vp0.execute-api.us-east-1.amazonaws.com/confqa',
  STREAM_API: 'https://6yt8pgh6tk.execute-api.us-east-1.amazonaws.com/confqa',
  LOG_LEVEL: 'error',
  QUESTIONS_CF_API: 'https://d2z1tgia19twdr.cloudfront.net',
};
